import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

const sendActivationEmail = (userId: string): Promise<AxiosResponse<null>> => {
  return client.post(`users/${userId}/send-activation-email/`);
};

export default function useSendActivationEmail(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  return useMutation(sendActivationEmail);
}
